export default theme => ({
  noBorder: {
    borderTop: 'none',
    paddingTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
  },
});
